import React, { useState } from 'react';
import './index.scss';
import { apiHolder, getIn18Text } from 'api';
import { ProductProtocols } from '@web-common/utils/constant';
import logo from '../../../images/electron/logo.svg';
import logoWaimao from '@/images/favicon_edm.png';
import aboutClose from '../../../images/electron/about_close.svg';
import wyLogo from '../../../images/wylogo.png';
const systemApi = apiHolder.api.getSystemApi();
const isWebWmEntry = systemApi.isWebWmEntry();
const About = props => {
    const { isElectron, isVisible, toggle } = props;
    const [visible, setVisible] = useState(isVisible);
    const toggleHandle = () => {
        setVisible(!visible);
        return visible;
    };
    if (toggle)
        toggle(toggleHandle);
    const openProtocol = (type) => {
        let url = '';
        if (type === 'service') {
            url = ProductProtocols.agreement;
        }
        else if (type === 'legal') {
            url = ProductProtocols.privacy;
        }
        systemApi.openNewWindow(url);
    };
    const logoSrc = systemApi.inEdm() ? logoWaimao : logo;
    const productName = systemApi.inEdm() ? getIn18Text('WANGYIWAIMAOTONG') : getIn18Text('WANGYILINGXIBAN');
    return visible ? (React.createElement("div", { className: `${isWebWmEntry ? 'web-wm-entry' : ''} about-mask ${isElectron ? ' no-mask' : ''}` },
        React.createElement("div", { className: "about-container" },
            isElectron ? null : React.createElement("img", { alt: "", src: aboutClose, onClick: toggleHandle, className: "about-close" }),
            React.createElement("div", { className: "about-wrap" },
                React.createElement("img", { src: logoSrc, className: "logo", alt: "", width: "56" }),
                React.createElement("div", { className: "name" }, productName),
                React.createElement("div", { className: "version" },
                    getIn18Text('BANBENHAO\uFF1A'),
                    window.siriusVersion),
                React.createElement("div", { className: "protocol-wrap" },
                    React.createElement("span", { onClick: () => openProtocol('service') }, getIn18Text('FUWUTIAOKUAN')),
                    React.createElement("span", { onClick: () => openProtocol('legal') }, getIn18Text('YINSIZHENGCE'))),
                React.createElement("div", { className: "footer-wrap" },
                    React.createElement("div", { className: "footer-content" },
                        React.createElement("img", { className: "about-logo", src: wyLogo, alt: "" }),
                        React.createElement("div", { className: "about-links" },
                            "163\u7F51\u6613\u514D\u8D39\u90AE",
                            React.createElement("span", null, "|"),
                            "188\u8D22\u5BCC\u90AE",
                            React.createElement("span", null, "|"),
                            "126\u7F51\u6613\u514D\u8D39\u90AE"))))))) : (React.createElement("div", null));
};
export default About;
